<!-- src/views/HomePage.vue -->
<template>
  <div class="c-text-column" style="    position: relative;top: -90px;">
    <div class="c-text-between px-container c-flex-wrap" style="margin: 80px 0;">
      <div class="display-width c-text-column" style="align-items: flex-start; justify-content: center;">
        <span class="c-mb-10">物理 AI 的参考平台</span>
      
        <div class="c-text-align">
          <h1 style="font-size: 40px;font-family: 'Montserrat', sans-serif;text-align: left;">移动式 FR3 Duo</h1>
          <span  class="bg-chetwode-blue text-white rounded-full uppercase inline-flex items-center justify-center px-[8px] py-[3px] text-[8px] leading-[5px] lg:text-[10px] lg:leading-[8px] whitespace-nowrap">
            原型</span>
        </div>
        <span class="c-mt-10 c-mb-10 c-text-left text-indent">
          移动式 FR3 Duo 通过与触觉移动机器人（TMR）集成，将 FR3 Duo 参考平台扩展至移动环境。它将双臂操作、丰富感知和全向移动能力融合于一个物理 AI 系统中，从而能够在固定工作单元之外进行数据采集和策略执行。
        </span>
        <div class="c-text-justify-start c-flex-wrap c-mt-10 c-mb-10">
          <router-link to="/contact" class="buttonSite  c-mr-20">抢先获取</router-link>
            <a style="border: 2px solid #1b2f36;padding: 4px 30px;cursor: pointer;border-radius: 5px;" class="newBack"
           href="https://franka.de/hubfs/MobileFR3Duo_TwoPager_February%202026.pdf?hsLang=en" target="_blank">下载两页简介</a>
        </div>
      </div>

      <div class="display-width c-text-align">
        <div style="aspect-ratio:  716/450;">
          <img src="@/assets/images/productsPage/260217_MFR3_Duo_Camera10_fp (1).png" style="width: 100%;aspect-ratio: 716/450;" />
        </div>
      </div>
    </div>

    <div style="background: #eff1f3;   padding-bottom: 5px;" class=" c-pdt-20">
      <div class="line-with-text px-container" id="system-image">
        <hr class="divider">
        <span class="line-text">为什么选择移动式 FR3 Duo</span>
        <hr class="divider">
      </div>

      <div class="c-text-between px-container c-flex-wrap " style="margin-bottom: 80px;gap: 40px;">
        <div class="display-width c-text-column ">
          <div class="c-text-justify-start">
            <h3 class="c-text-left c-mr-10">移动中的 FR3</h3>
          </div>
          <span class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
            移动式 FR3 Duo 将遥操作、数据集生成和策略执行统一于动态环境之中。通过将 FR3 Duo 优化的双臂运动学与 TMR 的全向移动底盘相结合，它能够实现面向真实世界操作任务的全身协调。
          </span>

        </div>
        <div class="display-width c-text-column ">
          <div class="c-text-justify-start">
            <h3 class="c-text-left c-mr-10">集成式移动操作</h3>
          </div>
          <span class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
           机械、电气和软件接口均已预先集成。该系统以统一的架构交付，与分别组装移动底盘和机械臂相比，大幅缩短了集成时间。研究人员可以专注于实验本身，而非系统工程。
          </span>
        </div>
        <div class="display-width c-text-column ">
           <div class="c-text-justify-start">
            <h3 class="c-text-left c-mr-10">物理 AI 的参考平台</h3>
          </div>
          <span class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
            全球研究人员可通过使用参考平台生成共享数据集，或复用他人数据集来训练模型。借助相同的平台配置，他们还可以对模型进行微调、开箱即用地执行策略，以及对策略性能进行基准测试。
          </span>
        </div>
        <div class="display-width c-text-column ">
           <div class="c-text-justify-start">
            <h3 class="c-text-left c-mr-10">先进感知与可扩展性</h3>
          </div>
          <span class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
            移动式 FR3 Duo 继承了 TMR 的完整传感器套件（激光雷达、摄像头、IMU），并将其与 FR3 的触觉灵敏度以及 FR3 Duo 的视觉与操作配件相结合。标准化的安装点允许扩展额外的传感器、计算单元或特定任务的工具，确保能够适应不断变化的研究需求。
          </span>
        </div>
      </div>
    </div>
    
    <div style="margin-bottom: 80px;margin-top: 80px;    align-items: flex-start;"
      class="c-text-both c-text-justify-start  px-container c-flex-wrap">
      <div class="c-text-column flex-width c-mb-40">
        <img src="@/assets/images/productsPage/Group 1756.png" alt=""
          style="    max-height: 100%;max-width: 100%;height: 65px; object-fit: contain;">
        <div class="c-mt-5 c-mb-20">基座尺寸</div>
        <div style="color: #4266a1;">800x580x294 mm</div>
      </div>
      <div class="c-text-column flex-width c-mb-40">
        <img src="@/assets/images/productsPage/Group 1756.png" alt=""
          style="    max-height: 100%;max-width: 100%;height: 65px; object-fit: contain;">
        <div class="c-mt-5 c-mb-20">每臂工作半径</div>
        <div style="color: #4266a1;">855 mm</div>
      </div>
      <div class="c-text-column flex-width c-mb-40">
        <img src="@/assets/images/productsPage/Group 1788.png" alt=""
          style="    max-height: 100%;max-width: 100%;height: 65px; object-fit: contain;">
        <div class="c-mt-5 c-mb-20">有效载荷</div>
        <div style="color: #4266a1;">100 kg（基座）</div>
        <div style="color: #4266a1;">3 kg（每臂）</div>
      </div> 
      <div class="c-text-column flex-width c-mb-40">
        <img src="@/assets/images/productsPage/Speed Icon 2.svg" alt=""
          style="    max-height: 100%;max-width: 100%;height: 65px; object-fit: contain;">
        <div class="c-mt-5 c-mb-20">最大速度</div>
        <div style="color: #4266a1;">1,75 m/s</div>
      </div>
      <div class="c-text-column flex-width c-mb-40">
        <img src="@/assets/images/productsPage/Accessories Icon (1).svg" alt=""
          style="    max-height: 100%;max-width: 100%;height: 65px; object-fit: contain;">
        <div class="c-mt-5 c-mb-20">嵌入式传感器</div>
        <div style="color: #4266a1;">14 个臂扭矩传感器</div>
        <div style="color: #4266a1;">2 个激光雷达</div>
        <div style="color: #4266a1;">7 个摄像头</div>
        <div style="color: #4266a1;">1 个 IMU</div>
        <div style="color: #4266a1;">计算图标-1</div>
      </div>
      <div class="c-text-column flex-width c-mb-40">
        <img src="@/assets/images/productsPage/Compute Icon-1.svg" alt=""
          style="    max-height: 100%;max-width: 100%;height: 65px; object-fit: contain;">
        <div class="c-mt-5 c-mb-20">用户 PC</div>
        <div style="color: #4266a1;">NVIDIA Jetson</div>
        <div style="color: #4266a1;">AGX Orin</div>
      </div> 
      <div class="c-text-column flex-width c-mb-40">
        <img src="@/assets/images/productsPage/Connectivity Icon-4.svg" alt=""
          style="    max-height: 100%;max-width: 100%;height: 65px; object-fit: contain;">
        <div class="c-mt-5 c-mb-20">连接性</div>
        <div style="color: #4266a1;">Wi-Fi、以太网</div>
        <div style="color: #4266a1;">USB、蓝牙</div>
      </div>
    </div>
    <div style="background: #eff1f3;  " class=" c-pdt-20">
      <div class="line-with-text px-container ">
        <hr class="divider">
        <span class="line-text">包含项及选项
        </span>
        <hr class="divider">
      </div>
       <div class="c-text-between px-container c-flex-wrap " style="margin-bottom: 120px; ">
        <div class="display-width c-text-column c-mb-60  c-pdr-40"
          style="align-items: flex-start; justify-content: center;">
          <h3>降低集成难度，实现可复现的结果</h3>
          <span class="c-mt-20 c-mb-10 text-indent" style="text-align: left;">
            移动式 FR3 Duo 包含两台 FR3 机器人和一个 FR3 Duo 安装套件（包括 FR3 Duo 支架和 FR3 Duo 外罩）。此外，还包含触觉移动机器人（TMR）。
          </span>
          <span class="c-mt-5 c-mb-10 text-indent" style="text-align: left;">
           FR3 Duo 可选配由 Franka 精选的 FR3 Duo 视觉与操作套件。完整的可选套件包括：两个带有共用电源的 Robotiq 2F-85 夹爪、两个带有专用支架和线缆的 RealSense D405 腕部摄像头，以及一个安装在 Franka 头部支架上的 Stereolab ZED Mini 立体摄像头。
          </span>
        </div>
        <div class="display-width c-text-both" style="aspect-ratio: 716/450;">
          <div class="carousel-container">
            <div class="carousel" @mouseenter="pauseCarousel" @mouseleave="resumeCarousel">
              <div class="slides-wrapper" :style="{ transform: `translateX(-${activeIndex * 100}%)` }">
                <div v-for="(img, index) in images" :key="index" class="slide">
                  <img :src="img.src" :alt="img.alt" class="carousel-img">
                </div>
              </div>

              <button class="carousel-btn prev" @click="prevSlide">
                <svg width="11" height="16" viewBox="0 0 11 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10 15L2 8L10 1" stroke="white" stroke-width="2"></path>
                </svg>
              </button>
              <button class="carousel-btn next" @click="nextSlide">
                <svg width="11" height="16" viewBox="0 0 11 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 15L9 8L1 1" stroke="white" stroke-width="2"></path>
                </svg>
              </button>

              <div class="carousel-indicators">
                <span v-for="(img, index) in images" :key="'indicator-' + index"
                  :class="{ active: activeIndex === index }" @click="goToSlide(index)"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <a href="https://example.com/" target="_blank">
      <img src="@/assets/images/productsPage/251105_Static_Spine_Camera01_fp (1)-1.png" alt="" class="desktop-image">
    </a>
    <a href="https://example.com/" target="_blank">
      <img src="@/assets/images/productsPage/251105_Static_Spine_Camera01_fp (1)_resized_mobileversion-1.png" alt="" class="mobile-image">
    </a>
    <div class="line-with-text px-container">
      <hr class="divider">
      <span class="line-text">高精度运动控制</span>
      <hr class="divider">
    </div>
    <div class="c-text-between px-container c-flex-wrap " style="margin-bottom: 80px;">
      <div class="display-width c-text-column  c-pdr-40" style="align-items: flex-start; justify-content: center;">
        <h1 class="c-text-left">FRANKA控制接口（FCI）</h1>

        <span class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
         Franka 控制接口（FCI）专为需要对机器人进行精细控制并访问实时传感器数据的机器人专家而设计。它非常适合运动控制研究以及开发大多数机器人无法实现的高度特定行为。
        </span>

        <a href="https://frankarobotics.github.io/docs/" class="linkTag" target="_blank"> 阅读文档</a>

      </div>
      <div class="display-width c-text-both" style="aspect-ratio: 716/450;">
        <img src="@/assets/images/productsPage/Flow Graphic V3.jpg" style=" height: 100%; max-width: 100%;" />
      </div>
    </div>

    <div class="c-text-between px-container c-flex-wrap " style="margin-bottom: 80px;">
      <div class="display-width c-text-column ">
        <h1 class="c-text-left">全开放直接控制</h1>
        <span class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
          FCI提供机器人的底层实时直接控制（无内部转换），仅通过内部监控防止自损，并开放控制回路权限，支持关节空间的位置/速度/扭矩及笛卡尔空间的位置/速度控制。
        </span>
      </div>
      <div class="display-width c-text-column ">
        <h1 class="c-text-left">数据采集</h1>
        <span class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
          以1kHz频率采集传感器与模型中的系统状态数据，FCI还提供外力估计及深度参数分析。
        </span>
      </div>
    </div>
    <div class="c-text-between px-container c-flex-wrap " style="margin-bottom: 80px;">
      <div class="display-width c-text-column ">
        <h1 class="c-text-left">开发者社区</h1>
        <span class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
          加入Franka Robotics开发者社区，使用C++、ROS 2或MATLAB/Simulink加速机器人研发创新。
        </span>
      </div>
      <div class="display-width c-text-column ">
        <h1 class="c-text-left">安全防护</h1>
        <span class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
          实施自定义安全规则，确保操作人员安全防护。
        </span>
      </div>
    </div>

    <div class="c-text-between px-container c-flex-wrap " style="margin-bottom: 80px;">
      <div class="display-width c-text-both" style="aspect-ratio: 716/450;">
        <img src="@/assets/images/productsPage/_Frank Robotics0615_resized-1 (1).jpg"
          style=" height: auto; width: 100%;" />
      </div>
      <div class="display-width c-text-column  c-pdr-40" style="align-items: flex-start;">
        <h1 class="c-text-left">实时控制与ROS集成</h1>
        <span class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
          Franka控制接口（FCI） 提供快速、底层的双向连接，直接控制机械臂与末端执行器。它实时反馈机器人状态，并支持通过以太网连接的外部工作站PC进行直接控制。通过我们的开源C++接口 libfranka，您可以以 1
          kHz
          的频率发送实时控制指令，支持以下5种接口：
        </span>
        <li class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
          关节级扭矩指令（含重力与摩擦补偿）
        </li>
        <li class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
          关节位置/速度指令
        </li>
        <li class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
          笛卡尔位姿/速度指令
        </li>
        <span class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
          同时，您可获取 1 kHz 的测量数据，包括：
        </span>
        <li class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
          关节数据（如位置、速度及连杆侧扭矩传感器信号）
        </li>
        <li class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
          外部施加扭矩与力的估计值
        </li>
        <li class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
          碰撞与接触信息
        </li>
        <span class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
          机器人模型库提供：
        </span>
        <li class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
          所有关节的正运动学计算
        </li>
        <li class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
          所有关节的雅可比矩阵
        </li>
        <li class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
          动力学模型、惯性矩阵、科里奥利力与重力矢量
        </li>
        <span class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
          此外，franka_ros将Franka机器人接入完整ROS 2生态系统，通过libfranka与ROS 2
          Control集成，提供机器人及末端执行器的URDF模型和精细3D网格（支持RViz可视化与Gazebo仿真），并借助MoveIt!集成简化运动规划与夹爪控制，同时提供基于ROS 2的机器人操作示例。
        </span>
      </div>
    </div>
    <div id="product-add-ons"></div>
    <img src="@/assets/images/productsPage/_Frank Robotics4381_Franka Grey_resized - bearbeitet.jpg" alt="" class="desktop-image">
    <img src="@/assets/images/productsPage/_Frank Robotics4381_Franka Grey_resized_portrait.jpg" alt="" class="mobile-image">

    <div id="product-add-ons"></div>
    <div class="line-with-text px-container">
      <hr class="divider">
      <span class="line-text">开发</span>
      <hr class="divider">
    </div>
    <div class="c-text-between px-container c-flex-wrap">
      <div class="display-width">
        <img src="@/assets/images/productsPage/Franka_Robotics.jpg" alt="" style="    height: auto; max-width: 100%;">
      </div>

      <div class="display-width c-text-column  c-pdr-40" style="align-items: flex-start; justify-content: center;">
        <span class="c-mb-10">构建、创造、创新</span>
        <h1>在 Franka 机器人平台上开发 </h1>

        <span class="c-mt-5 c-mb-10 text-indent" style="text-align: left;">Franka Research 3的机器人系统包括机械臂及其控制箱。
          面向 Franka Research 3 机器人平台开发者的资源中心。深入了解丰富的工具、库和文档，助力加速您的开发之旅。无论您是经验丰富的开发者，还是刚刚起步，都能在这里找到构建、创造和创新所需的一切。</span>
        <div class="c-text-justify-start c-flex-wrap c-mt-10 c-mb-10">
          <div class="buttonSite">
            <!-- documents -->
            <!-- <a href="/#/resources" target="_blank">获取资料</a> -->
            <a href="/#/develop" target="_blank">了解更多</a>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="c-text-column c-text-both action-height px-container" 
            style="align-items: flex-start; justify-content: center;">
            <h2 class="c-zIndex-2">对我们的产品感兴趣吗？</h2>
            <div class="c-text-justify-start c-flex-wrap c-mt-10 c-mb-10 c-zIndex-2"> 
                  <router-link to="/contact" class="buttonSite">联系我们</router-link> 
            </div>
            <div style="position: absolute;right: 0;height: 100%;"> 
              <img src="@/assets/images/productsPage/FR3 move new 6.png" alt=""
              style="    height: 100%; max-width: 100%;">
            </div> 
        </div> -->

  </div>
</template>

<script>

import backgroundImage from "@/assets/images/productsPage/FR3 move new 6.png";
export default {
  metaInfo() {
    return {
      title: this.$route.meta.title, // 从路由获取标题
      meta: [
        {
          name: 'keywords',
          content: this.$route.meta.metaTags[0]['content']
        }
      ]
    }
  },
  name: 'HomePage',
  data() {
    return {
      activeIndex: 0,
      carouselInterval: null,
      isTransitioning: false,
      images: [
        { src: require('@/assets/images/productsPage/Screenshot 2026-04-09 at 14.27.36 (1).png'), alt: 'Franka Robotics产品图片1' },
        { src: require('@/assets/images/productsPage/Screenshot 2026-04-09 at 14.24.05.png'), alt: 'Franka Robotics产品图片2' },
        { src: require('@/assets/images/productsPage/Screenshot 2026-04-09 at 14.21.11.png'), alt: 'Franka Robotics产品图片3' },
        { src: require('@/assets/images/productsPage/Screenshot 2026-04-09 at 14.25.59.png'), alt: 'Franka Robotics产品图片4' },
        { src: require('@/assets/images/productsPage/260217_MFR3_Duo_Camera18_03_fp_resized.png'), alt: 'Franka Robotics产品图片5' },
         
      ],
      iframe1: '2',
      iframe2: '2',
      backgroundImage: backgroundImage,
      tableData: [
        { name: '基于工作流的应用程序编程', DESK: true, RIDE: false, FCI: false },
        { name: '快速原型设计实验和演示 ', DESK: true, RIDE: false, FCI: false },
        { name: '执行机器人任务', DESK: true, RIDE: false, FCI: true },
        { name: '开发自定义应用程序', DESK: false, RIDE: true, FCI: false },
        { name: '连接第三方硬件', DESK: false, RIDE: true, FCI: true },
        { name: '连接外部资源', DESK: false, RIDE: true, FCI: true },
        { name: '1 kHz 力矩、位置和速度控制 ', DESK: false, RIDE: false, FCI: true },
        { name: '1 kHz 传感器信号和机器人状态的测量', DESK: false, RIDE: false, FCI: true },
        { name: '访问机器人运动学和动力学模型', DESK: false, RIDE: false, FCI: true },
        { name: '与ROS和MATLAB & Simulink的集成', DESK: false, RIDE: false, FCI: true },
      ]
    }

  },
  mounted() {
    this.startCarousel();
  },
  beforeUnmount() {
    clearInterval(this.carouselInterval);
  },
  methods: {
    startCarousel() {
      this.carouselInterval = setInterval(() => {
        this.nextSlide();
      }, 5000);
    },
    nextSlide() {
      if (this.isTransitioning) return;
      this.isTransitioning = true;

      this.activeIndex = (this.activeIndex + 1) % this.images.length;

      setTimeout(() => {
        this.isTransitioning = false;
      }, 500); // 与过渡时间保持一致
    },
    prevSlide() {
      if (this.isTransitioning) return;
      this.isTransitioning = true;

      this.activeIndex = (this.activeIndex - 1 + this.images.length) % this.images.length;

      setTimeout(() => {
        this.isTransitioning = false;
      }, 500);
    },
    goToSlide(index) {
      if (this.isTransitioning || index === this.activeIndex) return;
      this.isTransitioning = true;

      this.activeIndex = index;

      setTimeout(() => {
        this.isTransitioning = false;
      }, 500);
    },
    pauseCarousel() {
      clearInterval(this.carouselInterval);
    },
    resumeCarousel() {
      this.startCarousel();
    }
  }
};
</script>
<style scoped>
.newBack:hover {
  background-color: #1b2f36;
  color: white;
}

.desktop-image {
  display: block;
  width: 100%;
}

.mobile-image {
  display: none;
  width: 100%;
}

@media (max-width: 999px) {
  .desktop-image {
    display: none;
  }
  .mobile-image {
    display: block;
  }
}

/* 新增轮播图样式 - 水平滑动效果 */
.carousel-container {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.carousel {
  position: relative;
  width: 100%;
  height: 100%;
}

.slides-wrapper {
  display: flex;
  height: 100%;
  transition: transform 0.5s ease;
  will-change: transform;
}

.slide {
  flex: 0 0 100%;
  min-width: 100%;
  position: relative;
}

.carousel-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.carousel-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 40px;
  height: 40px;
  background: rgba(0, 0, 0, 0);
  color: white;
  border: none;
  border-radius: 50%;
  font-size: 20px;
  cursor: pointer;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.3s ease;
}

.carousel-btn:hover {
  /* background: rgba(0,0,0,0.8); */
}

.carousel-btn.prev {
  left: 15px;
}

.carousel-btn.next {
  right: 15px;
}

.carousel-indicators {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 10px;
  z-index: 10;
}

.carousel-indicators span {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  transition: background 0.3s ease;
}

.carousel-indicators span.active {
  background: white;
}

li::marker {
  unicode-bidi: isolate;
  font-variant-numeric: tabular-nums;
  text-transform: none;
  text-indent: 0px !important;
  text-align: start !important;
  text-align-last: start !important;
}

.flex-width {
  width: calc(100% / 7);
}

@media (max-width: 1260px) {
  .flex-width {
    width: calc(100% / 4);
  }
}

@media (max-width: 999px) {
  .flex-width {
    width: calc(100% / 3);
  }
}

@media (max-width: 747px) {
  .flex-width {
    width: calc(100% / 2);
  }
}

@media (max-width: 150px) {
  .flex-width {
    width: 100%
  }
}

.title-width {
  width: 33.33%;
}

/* 屏幕宽度小于 900px 时，一行展示 2 个 */
@media (max-width: 899px) {
  .title-width {
    width: 100%
  }
}

.action-height {
  height: 400px;
  background-color: #d5dbdc;
  position: relative;
}

.action-width {
  width: calc(33% - 40px);
}

/* 屏幕宽度小于 900px 时，一行展示 2 个 */
@media (max-width: 1029px) {
  .action-width {
    width: calc(50% - 40px);
  }

  .action-height {
    height: 200px;
    background-color: #d5dbdc;
  }
}

/* 屏幕宽度小于 600px 时，一行展示 1 个 */
@media (max-width: 599px) {
  .action-width {
    width: 100%;
  }
}

table {
  width: 100%;
  border-collapse: collapse;
}

th,
td {
  border: 1px solid black;
  padding: 5px;
  text-align: left;
}
</style>